import { policyConfig } from "shared";
import { DateTime } from "luxon";
import { When } from "react-if";

import { fieldIsValid } from "../../../../../lib/helper";
import { Select } from "../../../../../../common/Atoms/Select";
import { useGetSelectedOrganisation } from "../../../../../hooks/useGetSelectedOrganisation";
import { Notification } from "../../../../../../common/Atoms/Notification";

import { IFieldProps } from "./fieldProps";

interface ITimeOfDayProps extends IFieldProps {
  labelOverride?: string;
  descriptionOverride?: string;
}

const config = policyConfig.hour_of_day;
// Matches the 3 hour send time grace in the backend policy checks
const LATE_HOUR_WARNING_FROM = 21;
const hourOptions = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  label: (i < 10 ? `0${i}` : i) + `:00`,
}));

export function TimeOfDay({
  policyFormData,
  invalids,
  handleChange,
  labelOverride,
  descriptionOverride,
}: ITimeOfDayProps) {
  const currentOrg = useGetSelectedOrganisation();
  const description = descriptionOverride || `The time of day in your company timezone to schedule the action to run at.`;
  const label = labelOverride || config.label;
  const orgTz = currentOrg?.validatedTimezone;

  const dt = DateTime.local().setZone(orgTz);

  const formatted = dt.toLocaleString(DateTime.DATETIME_MED);
  const helpText = `Your current company time is: ${formatted}`;

  return (
    <div>
      <Select
        label={ label }
        description={ description }
        helpIcon={ `The action may be ran slightly after the time dependent on your volumes` }
        options={ hourOptions }
        selected={ policyFormData.hour_of_day }
        onChange={ handleChange }
        helpText={ helpText }
        name={ `hour_of_day` }
        invalid={ fieldIsValid(`hour_of_day`, invalids) }
      />

      <When condition={ (policyFormData.hour_of_day ?? 0) >= LATE_HOUR_WARNING_FROM }>
        <Notification type={ `warning` }>
          { `If this policy sends a lot of actions on the same day, there may not be time to send them all. Actions go out gradually, and any not sent within 3 hours of this time are skipped. Pick an earlier time if you have large volumes.` }
        </Notification>
      </When>
    </div>
  );
}
